import * as g from "react";
import Cr, { useMemo as Lr, isValidElement as er, useState as tr } from "react";
import { IconContext as Nt, CalendarBlank as rr, Circle as Hr, CalendarDots as Wr, ArrowLineLeft as Ir, ArrowLeft as Br, ArrowRight as Yr, ArrowLineRight as Ur, X as Sr, CaretDown as $r, CaretUp as qr, DotsThree as Vr } from "@phosphor-icons/react";
import { flushSync as Gr } from "react-dom";
function Xr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Pt = { exports: {} }, pt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nr;
function Kr() {
  if (nr) return pt;
  nr = 1;
  var e = Cr, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, f, b) {
    var h, E = {}, k = null, S = null;
    b !== void 0 && (k = "" + b), f.key !== void 0 && (k = "" + f.key), f.ref !== void 0 && (S = f.ref);
    for (h in f) n.call(f, h) && !o.hasOwnProperty(h) && (E[h] = f[h]);
    if (u && u.defaultProps) for (h in f = u.defaultProps, f) E[h] === void 0 && (E[h] = f[h]);
    return { $$typeof: t, type: u, key: k, ref: S, props: E, _owner: i.current };
  }
  return pt.Fragment = r, pt.jsx = s, pt.jsxs = s, pt;
}
var xt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ar;
function Qr() {
  return ar || (ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Cr, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), M = Symbol.iterator, x = "@@iterator";
    function v(a) {
      if (a === null || typeof a != "object")
        return null;
      var c = M && a[M] || a[x];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function d(a) {
      {
        for (var c = arguments.length, y = new Array(c > 1 ? c - 1 : 0), O = 1; O < c; O++)
          y[O - 1] = arguments[O];
        _("error", a, y);
      }
    }
    function _(a, c, y) {
      {
        var O = C.ReactDebugCurrentFrame, L = O.getStackAddendum();
        L !== "" && (c += "%s", y = y.concat([L]));
        var W = y.map(function(T) {
          return String(T);
        });
        W.unshift("Warning: " + c), Function.prototype.apply.call(console[a], console, W);
      }
    }
    var j = !1, I = !1, X = !1, ne = !1, le = !1, B;
    B = Symbol.for("react.module.reference");
    function N(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === o || le || a === i || a === b || a === h || ne || a === S || j || I || X || typeof a == "object" && a !== null && (a.$$typeof === k || a.$$typeof === E || a.$$typeof === s || a.$$typeof === u || a.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === B || a.getModuleId !== void 0));
    }
    function F(a, c, y) {
      var O = a.displayName;
      if (O)
        return O;
      var L = c.displayName || c.name || "";
      return L !== "" ? y + "(" + L + ")" : y;
    }
    function P(a) {
      return a.displayName || "Context";
    }
    function U(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case b:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case u:
            var c = a;
            return P(c) + ".Consumer";
          case s:
            var y = a;
            return P(y._context) + ".Provider";
          case f:
            return F(a, a.render, "ForwardRef");
          case E:
            var O = a.displayName || null;
            return O !== null ? O : U(a.type) || "Memo";
          case k: {
            var L = a, W = L._payload, T = L._init;
            try {
              return U(T(W));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, Q = 0, ce, z, Se, xe, Fe, Me, Te;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function Pe() {
      {
        if (Q === 0) {
          ce = console.log, z = console.info, Se = console.warn, xe = console.error, Fe = console.group, Me = console.groupCollapsed, Te = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        Q++;
      }
    }
    function $() {
      {
        if (Q--, Q === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, a, {
              value: ce
            }),
            info: K({}, a, {
              value: z
            }),
            warn: K({}, a, {
              value: Se
            }),
            error: K({}, a, {
              value: xe
            }),
            group: K({}, a, {
              value: Fe
            }),
            groupCollapsed: K({}, a, {
              value: Me
            }),
            groupEnd: K({}, a, {
              value: Te
            })
          });
        }
        Q < 0 && d("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var A = C.ReactCurrentDispatcher, Z;
    function te(a, c, y) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (L) {
            var O = L.stack.trim().match(/\n( *(at )?)/);
            Z = O && O[1] || "";
          }
        return `
` + Z + a;
      }
    }
    var ae = !1, V;
    {
      var de = typeof WeakMap == "function" ? WeakMap : Map;
      V = new de();
    }
    function ye(a, c) {
      if (!a || ae)
        return "";
      {
        var y = V.get(a);
        if (y !== void 0)
          return y;
      }
      var O;
      ae = !0;
      var L = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var W;
      W = A.current, A.current = null, Pe();
      try {
        if (c) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (w) {
              O = w;
            }
            Reflect.construct(a, [], T);
          } else {
            try {
              T.call();
            } catch (w) {
              O = w;
            }
            a.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (w) {
            O = w;
          }
          a();
        }
      } catch (w) {
        if (w && O && typeof w.stack == "string") {
          for (var R = w.stack.split(`
`), oe = O.stack.split(`
`), G = R.length - 1, J = oe.length - 1; G >= 1 && J >= 0 && R[G] !== oe[J]; )
            J--;
          for (; G >= 1 && J >= 0; G--, J--)
            if (R[G] !== oe[J]) {
              if (G !== 1 || J !== 1)
                do
                  if (G--, J--, J < 0 || R[G] !== oe[J]) {
                    var ve = `
` + R[G].replace(" at new ", " at ");
                    return a.displayName && ve.includes("<anonymous>") && (ve = ve.replace("<anonymous>", a.displayName)), typeof a == "function" && V.set(a, ve), ve;
                  }
                while (G >= 1 && J >= 0);
              break;
            }
        }
      } finally {
        ae = !1, A.current = W, $(), Error.prepareStackTrace = L;
      }
      var Je = a ? a.displayName || a.name : "", D = Je ? te(Je) : "";
      return typeof a == "function" && V.set(a, D), D;
    }
    function Ge(a, c, y) {
      return ye(a, !1);
    }
    function ke(a) {
      var c = a.prototype;
      return !!(c && c.isReactComponent);
    }
    function be(a, c, y) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return ye(a, ke(a));
      if (typeof a == "string")
        return te(a);
      switch (a) {
        case b:
          return te("Suspense");
        case h:
          return te("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case f:
            return Ge(a.render);
          case E:
            return be(a.type, c, y);
          case k: {
            var O = a, L = O._payload, W = O._init;
            try {
              return be(W(L), c, y);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, Oe = {}, we = C.ReactDebugCurrentFrame;
    function ie(a) {
      if (a) {
        var c = a._owner, y = be(a.type, a._source, c ? c.type : null);
        we.setExtraStackFrame(y);
      } else
        we.setExtraStackFrame(null);
    }
    function Xe(a, c, y, O, L) {
      {
        var W = Function.call.bind(ge);
        for (var T in a)
          if (W(a, T)) {
            var R = void 0;
            try {
              if (typeof a[T] != "function") {
                var oe = Error((O || "React class") + ": " + y + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw oe.name = "Invariant Violation", oe;
              }
              R = a[T](c, T, O, y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              R = G;
            }
            R && !(R instanceof Error) && (ie(L), d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", O || "React class", y, T, typeof R), ie(null)), R instanceof Error && !(R.message in Oe) && (Oe[R.message] = !0, ie(L), d("Failed %s type: %s", y, R.message), ie(null));
          }
      }
    }
    var Ke = Array.isArray;
    function je(a) {
      return Ke(a);
    }
    function Ee(a) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, y = c && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return y;
      }
    }
    function pe(a) {
      try {
        return Ne(a), !1;
      } catch {
        return !0;
      }
    }
    function Ne(a) {
      return "" + a;
    }
    function Le(a) {
      if (pe(a))
        return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ee(a)), Ne(a);
    }
    var _e = C.ReactCurrentOwner, Ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, He;
    function We(a) {
      if (ge.call(a, "ref")) {
        var c = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function Lt(a) {
      if (ge.call(a, "key")) {
        var c = Object.getOwnPropertyDescriptor(a, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function ut(a, c) {
      typeof a.ref == "string" && _e.current;
    }
    function Ht(a, c) {
      {
        var y = function() {
          me || (me = !0, d("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        y.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: y,
          configurable: !0
        });
      }
    }
    function Mt(a, c) {
      {
        var y = function() {
          He || (He = !0, d("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        y.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: y,
          configurable: !0
        });
      }
    }
    var lt = function(a, c, y, O, L, W, T) {
      var R = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: a,
        key: c,
        ref: y,
        props: T,
        // Record the component responsible for creating this element.
        _owner: W
      };
      return R._store = {}, Object.defineProperty(R._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: O
      }), Object.defineProperty(R, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: L
      }), Object.freeze && (Object.freeze(R.props), Object.freeze(R)), R;
    };
    function kt(a, c, y, O, L) {
      {
        var W, T = {}, R = null, oe = null;
        y !== void 0 && (Le(y), R = "" + y), Lt(c) && (Le(c.key), R = "" + c.key), We(c) && (oe = c.ref, ut(c, L));
        for (W in c)
          ge.call(c, W) && !Ae.hasOwnProperty(W) && (T[W] = c[W]);
        if (a && a.defaultProps) {
          var G = a.defaultProps;
          for (W in G)
            T[W] === void 0 && (T[W] = G[W]);
        }
        if (R || oe) {
          var J = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          R && Ht(T, J), oe && Mt(T, J);
        }
        return lt(a, R, oe, L, O, _e.current, T);
      }
    }
    var ht = C.ReactCurrentOwner, vt = C.ReactDebugCurrentFrame;
    function he(a) {
      if (a) {
        var c = a._owner, y = be(a.type, a._source, c ? c.type : null);
        vt.setExtraStackFrame(y);
      } else
        vt.setExtraStackFrame(null);
    }
    var yt;
    yt = !1;
    function re(a) {
      return typeof a == "object" && a !== null && a.$$typeof === t;
    }
    function Ie() {
      {
        if (ht.current) {
          var a = U(ht.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function ct(a) {
      return "";
    }
    var bt = {};
    function Wt(a) {
      {
        var c = Ie();
        if (!c) {
          var y = typeof a == "string" ? a : a.displayName || a.name;
          y && (c = `

Check the top-level render call using <` + y + ">.");
        }
        return c;
      }
    }
    function Ot(a, c) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var y = Wt(c);
        if (bt[y])
          return;
        bt[y] = !0;
        var O = "";
        a && a._owner && a._owner !== ht.current && (O = " It was passed a child from " + U(a._owner.type) + "."), he(a), d('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', y, O), he(null);
      }
    }
    function Qe(a, c) {
      {
        if (typeof a != "object")
          return;
        if (je(a))
          for (var y = 0; y < a.length; y++) {
            var O = a[y];
            re(O) && Ot(O, c);
          }
        else if (re(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var L = v(a);
          if (typeof L == "function" && L !== a.entries)
            for (var W = L.call(a), T; !(T = W.next()).done; )
              re(T.value) && Ot(T.value, c);
        }
      }
    }
    function _t(a) {
      {
        var c = a.type;
        if (c == null || typeof c == "string")
          return;
        var y;
        if (typeof c == "function")
          y = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === E))
          y = c.propTypes;
        else
          return;
        if (y) {
          var O = U(c);
          Xe(y, a.props, "prop", O, a);
        } else if (c.PropTypes !== void 0 && !yt) {
          yt = !0;
          var L = U(c);
          d("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", L || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && d("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function It(a) {
      {
        for (var c = Object.keys(a.props), y = 0; y < c.length; y++) {
          var O = c[y];
          if (O !== "children" && O !== "key") {
            he(a), d("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", O), he(null);
            break;
          }
        }
        a.ref !== null && (he(a), d("Invalid attribute `ref` supplied to `React.Fragment`."), he(null));
      }
    }
    var Rt = {};
    function dt(a, c, y, O, L, W) {
      {
        var T = N(a);
        if (!T) {
          var R = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var oe = ct();
          oe ? R += oe : R += Ie();
          var G;
          a === null ? G = "null" : je(a) ? G = "array" : a !== void 0 && a.$$typeof === t ? (G = "<" + (U(a.type) || "Unknown") + " />", R = " Did you accidentally export a JSX literal instead of a component?") : G = typeof a, d("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, R);
        }
        var J = kt(a, c, y, L, W);
        if (J == null)
          return J;
        if (T) {
          var ve = c.children;
          if (ve !== void 0)
            if (O)
              if (je(ve)) {
                for (var Je = 0; Je < ve.length; Je++)
                  Qe(ve[Je], a);
                Object.freeze && Object.freeze(ve);
              } else
                d("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Qe(ve, a);
        }
        if (ge.call(c, "key")) {
          var D = U(a), w = Object.keys(c).filter(function(ee) {
            return ee !== "key";
          }), H = w.length > 0 ? "{key: someKey, " + w.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Rt[D + H]) {
            var q = w.length > 0 ? "{" + w.join(": ..., ") + ": ...}" : "{}";
            d(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, H, D, q, D), Rt[D + H] = !0;
          }
        }
        return a === n ? It(J) : _t(J), J;
      }
    }
    function Ft(a, c, y) {
      return dt(a, c, y, !0);
    }
    function Tt(a, c, y) {
      return dt(a, c, y, !1);
    }
    var Bt = Tt, Yt = Ft;
    xt.Fragment = n, xt.jsx = Bt, xt.jsxs = Yt;
  }()), xt;
}
var ir;
function Jr() {
  return ir || (ir = 1, process.env.NODE_ENV === "production" ? Pt.exports = Kr() : Pt.exports = Qr()), Pt.exports;
}
var l = Jr();
const zr = ({
  variant: e = "primary",
  size: t = "medium",
  text: r,
  iconBefore: n,
  iconAfter: i,
  className: o,
  disabled: s = !1,
  ...u
}) => {
  const f = !r && (!!n || !!i);
  return /* @__PURE__ */ l.jsx(
    "button",
    {
      className: ue(
        "flex gap-2 justify-center items-center",
        Zr(e),
        en(t),
        {
          "rounded-full": f,
          "rounded-md": !f
        },
        o
      ),
      disabled: s,
      ...u,
      children: /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs(
        Nt.Provider,
        {
          value: {
            size: t === "xsmall" ? 8 : 16,
            weight: "regular",
            className: ue(or(e), {
              "text-label-tertiary": s
            })
          },
          children: [
            n && n,
            r && /* @__PURE__ */ l.jsx(
              Ve,
              {
                variant: t === "xsmall" ? "M" : t === "small" ? "B2Button" : "B1Button",
                className: ue(or(e), {
                  "text-label-tertiary": s
                }),
                children: r
              }
            ),
            i && i
          ]
        }
      ) })
    }
  );
}, Zr = (e) => {
  switch (e) {
    case "primary":
      return "bg-primary-action-button hover:bg-primary-action-background-2 disabled:bg-primary-action-disabled";
    case "neutral":
      return "border border-separator-regular bg-secondary-action-complementary hover:bg-secondary-action-alternative disabled:bg-secondary-action-disabled disabled:border-separator-opaque";
    case "subtle":
      return "border border-[rgba(255,255,255,0.0)] hover:border-separator-regular disabled:bg-secondary-action-disabled disabled:border-separator-opaque";
  }
}, or = (e) => {
  switch (e) {
    case "primary":
      return "text-label-quaternary";
    case "neutral":
      return "text-label-primary";
    case "subtle":
      return "text-label-secondary";
  }
}, en = (e) => {
  switch (e) {
    case "xsmall":
      return "p-1";
    case "small":
      return "p-2";
    case "medium":
      return "p-3";
  }
}, Ka = ({
  variant: e = "primary",
  size: t = "medium",
  text: r,
  iconBefore: n,
  iconAfter: i,
  className: o,
  disabled: s = !1,
  ...u
}) => {
  const f = !r && (!!n || !!i);
  return /* @__PURE__ */ l.jsx(
    "button",
    {
      className: ue(
        "flex gap-2 justify-center items-center group",
        tn(e),
        rn(t),
        {
          "rounded-full": f,
          "rounded-md": !f
        },
        o
      ),
      disabled: s,
      ...u,
      children: /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs(
        Nt.Provider,
        {
          value: {
            size: t === "xsmall" ? 8 : 16,
            weight: "regular",
            className: ue(sr(e), {
              "[&]:text-label-tertiary [&]:group-hover:text-label-tertiary": s
            })
          },
          children: [
            n && n,
            r && /* @__PURE__ */ l.jsx(
              Ve,
              {
                variant: t === "xsmall" ? "M" : t === "small" ? "B2Button" : "B1Button",
                className: ue(sr(e), {
                  "[&]:text-label-tertiary [&]:group-hover:text-label-tertiary": s
                }),
                children: r
              }
            ),
            i && i
          ]
        }
      ) })
    }
  );
}, tn = (e) => {
  switch (e) {
    case "primary":
      return "bg-danger-background hover:bg-danger-hover disabled:bg-primary-action-disabled disabled:border disabled:border-separator-opaque";
    case "subtle":
      return "border hover:bg-danger-background border-[rgba(255,255,255,0.0)] hover:border-danger-accessible disabled:bg-secondary-action-disabled disabled:border-separator-opaque";
  }
}, sr = (e) => {
  switch (e) {
    case "primary":
      return "[&]:text-danger-accessible group-hover:text-label-quaternary";
    case "subtle":
      return "[&]:text-danger-accessible";
  }
}, rn = (e) => {
  switch (e) {
    case "xsmall":
      return "p-1";
    case "small":
      return "p-2";
    case "medium":
      return "p-3";
  }
}, nn = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, an = (e, t, r) => {
  let n;
  const i = nn[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Ut(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const on = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, sn = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, un = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ln = {
  date: Ut({
    formats: on,
    defaultWidth: "full"
  }),
  time: Ut({
    formats: sn,
    defaultWidth: "full"
  }),
  dateTime: Ut({
    formats: un,
    defaultWidth: "full"
  })
}, cn = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, dn = (e, t, r, n) => cn[e];
function wt(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let i;
    if (n === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, u = r != null && r.width ? String(r.width) : s;
      i = e.formattingValues[u] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, u = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[u] || e.values[s];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[o];
  };
}
const fn = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, gn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mn = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, hn = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, vn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, yn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bn = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, pn = {
  ordinalNumber: bn,
  era: wt({
    values: fn,
    defaultWidth: "wide"
  }),
  quarter: wt({
    values: gn,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: wt({
    values: mn,
    defaultWidth: "wide"
  }),
  day: wt({
    values: hn,
    defaultWidth: "wide"
  }),
  dayPeriod: wt({
    values: vn,
    defaultWidth: "wide",
    formattingValues: yn,
    defaultFormattingWidth: "wide"
  })
};
function Et(e) {
  return (t, r = {}) => {
    const n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    const s = o[0], u = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], f = Array.isArray(u) ? wn(u, (E) => E.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      xn(u, (E) => E.test(s))
    );
    let b;
    b = e.valueCallback ? e.valueCallback(f) : f, b = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(b)
    ) : b;
    const h = t.slice(s.length);
    return { value: b, rest: h };
  };
}
function xn(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function wn(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function En(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const i = n[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let s = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    s = r.valueCallback ? r.valueCallback(s) : s;
    const u = t.slice(i.length);
    return { value: s, rest: u };
  };
}
const Cn = /^(\d+)(th|st|nd|rd)?/i, Sn = /\d+/i, Mn = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, kn = {
  any: [/^b/i, /^(a|c)/i]
}, On = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, _n = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rn = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Fn = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Tn = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Dn = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Pn = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jn = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Nn = {
  ordinalNumber: En({
    matchPattern: Cn,
    parsePattern: Sn,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Et({
    matchPatterns: Mn,
    defaultMatchWidth: "wide",
    parsePatterns: kn,
    defaultParseWidth: "any"
  }),
  quarter: Et({
    matchPatterns: On,
    defaultMatchWidth: "wide",
    parsePatterns: _n,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Et({
    matchPatterns: Rn,
    defaultMatchWidth: "wide",
    parsePatterns: Fn,
    defaultParseWidth: "any"
  }),
  day: Et({
    matchPatterns: Tn,
    defaultMatchWidth: "wide",
    parsePatterns: Dn,
    defaultParseWidth: "any"
  }),
  dayPeriod: Et({
    matchPatterns: Pn,
    defaultMatchWidth: "any",
    parsePatterns: jn,
    defaultParseWidth: "any"
  })
}, An = {
  code: "en-US",
  formatDistance: an,
  formatLong: ln,
  formatRelative: dn,
  localize: pn,
  match: Nn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let Ln = {};
function At() {
  return Ln;
}
const Mr = 6048e5, Hn = 864e5, ur = Symbol.for("constructDateFrom");
function tt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && ur in e ? e[ur](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Re(e, t) {
  return tt(t || e, e);
}
function lr(e) {
  const t = Re(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function Wn(e, ...t) {
  const r = tt.bind(
    null,
    t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function cr(e, t) {
  const r = Re(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
function In(e, t, r) {
  const [n, i] = Wn(
    r == null ? void 0 : r.in,
    e,
    t
  ), o = cr(n), s = cr(i), u = +o - lr(o), f = +s - lr(s);
  return Math.round((u - f) / Hn);
}
function Bn(e, t) {
  const r = Re(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Yn(e, t) {
  const r = Re(e, t == null ? void 0 : t.in);
  return In(r, Bn(r)) + 1;
}
function Ct(e, t) {
  var u, f, b, h;
  const r = At(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((h = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : h.weekStartsOn) ?? 0, i = Re(e, t == null ? void 0 : t.in), o = i.getDay(), s = (o < n ? 7 : 0) + o - n;
  return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
}
function jt(e, t) {
  return Ct(e, { ...t, weekStartsOn: 1 });
}
function kr(e, t) {
  const r = Re(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = tt(r, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const o = jt(i), s = tt(r, 0);
  s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0);
  const u = jt(s);
  return r.getTime() >= o.getTime() ? n + 1 : r.getTime() >= u.getTime() ? n : n - 1;
}
function Un(e, t) {
  const r = kr(e, t), n = tt(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), jt(n);
}
function $n(e, t) {
  const r = Re(e, t == null ? void 0 : t.in), n = +jt(r) - +Un(r);
  return Math.round(n / Mr) + 1;
}
function Or(e, t) {
  var h, E, k, S;
  const r = Re(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = At(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((E = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : E.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((S = (k = i.locale) == null ? void 0 : k.options) == null ? void 0 : S.firstWeekContainsDate) ?? 1, s = tt((t == null ? void 0 : t.in) || e, 0);
  s.setFullYear(n + 1, 0, o), s.setHours(0, 0, 0, 0);
  const u = Ct(s, t), f = tt((t == null ? void 0 : t.in) || e, 0);
  f.setFullYear(n, 0, o), f.setHours(0, 0, 0, 0);
  const b = Ct(f, t);
  return +r >= +u ? n + 1 : +r >= +b ? n : n - 1;
}
function qn(e, t) {
  var u, f, b, h;
  const r = At(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Or(e, t), o = tt((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(i, 0, n), o.setHours(0, 0, 0, 0), Ct(o, t);
}
function Vn(e, t) {
  const r = Re(e, t == null ? void 0 : t.in), n = +Ct(r, t) - +qn(r, t);
  return Math.round(n / Mr) + 1;
}
function Y(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const et = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return Y(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : Y(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Y(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Y(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Y(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Y(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Y(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), i = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return Y(i, t.length);
  }
}, gt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, dr = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
      return r.ordinalNumber(i, { unit: "year" });
    }
    return et.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const i = Or(e, n), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const s = o % 100;
      return Y(s, 2);
    }
    return t === "Yo" ? r.ordinalNumber(o, { unit: "year" }) : Y(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = kr(e);
    return Y(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return Y(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return Y(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return Y(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return et.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return Y(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const i = Vn(e, n);
    return t === "wo" ? r.ordinalNumber(i, { unit: "week" }) : Y(i, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = $n(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Y(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : et.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = Yn(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Y(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const i = e.getDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return Y(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(o, { unit: "day" });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const i = e.getDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return Y(o, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), i = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return Y(i, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n === 12 ? i = gt.noon : n === 0 ? i = gt.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n >= 17 ? i = gt.evening : n >= 12 ? i = gt.afternoon : n >= 4 ? i = gt.morning : i = gt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return et.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : et.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Y(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Y(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : et.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : et.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return et.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return gr(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return at(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return at(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return gr(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return at(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return at(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + fr(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + at(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + fr(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + at(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return Y(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return Y(+e, t.length);
  }
};
function fr(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? r + String(i) : r + String(i) + t + Y(o, 2);
}
function gr(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Y(Math.abs(e) / 60, 2) : at(e, t);
}
function at(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Y(Math.trunc(n / 60), 2), o = Y(n % 60, 2);
  return r + i + t + o;
}
const mr = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, _r = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Gn = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
  if (!i)
    return mr(e, t);
  let o;
  switch (n) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", mr(n, t)).replace("{{time}}", _r(i, t));
}, Xn = {
  p: _r,
  P: Gn
}, Kn = /^D+$/, Qn = /^Y+$/, Jn = ["D", "DD", "YY", "YYYY"];
function zn(e) {
  return Kn.test(e);
}
function Zn(e) {
  return Qn.test(e);
}
function ea(e, t, r) {
  const n = ta(e, t, r);
  if (console.warn(n), Jn.includes(e)) throw new RangeError(n);
}
function ta(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function ra(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function na(e) {
  return !(!ra(e) && typeof e != "number" || isNaN(+Re(e)));
}
const aa = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ia = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oa = /^'([^]*?)'?$/, sa = /''/g, ua = /[a-zA-Z]/;
function hr(e, t, r) {
  var h, E, k, S;
  const n = At(), i = n.locale ?? An, o = n.firstWeekContainsDate ?? ((E = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : E.firstWeekContainsDate) ?? 1, s = n.weekStartsOn ?? ((S = (k = n.locale) == null ? void 0 : k.options) == null ? void 0 : S.weekStartsOn) ?? 0, u = Re(e, r == null ? void 0 : r.in);
  if (!na(u))
    throw new RangeError("Invalid time value");
  let f = t.match(ia).map((M) => {
    const x = M[0];
    if (x === "p" || x === "P") {
      const v = Xn[x];
      return v(M, i.formatLong);
    }
    return M;
  }).join("").match(aa).map((M) => {
    if (M === "''")
      return { isToken: !1, value: "'" };
    const x = M[0];
    if (x === "'")
      return { isToken: !1, value: la(M) };
    if (dr[x])
      return { isToken: !0, value: M };
    if (x.match(ua))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: M };
  });
  i.localize.preprocessor && (f = i.localize.preprocessor(u, f));
  const b = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: i
  };
  return f.map((M) => {
    if (!M.isToken) return M.value;
    const x = M.value;
    (Zn(x) || zn(x)) && ea(x, t, String(e));
    const v = dr[x[0]];
    return v(u, x, i.localize, b);
  }).join("");
}
function la(e) {
  const t = e.match(oa);
  return t ? t[1].replace(sa, "'") : e;
}
function rt(e) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rt(e);
}
function ca(e, t) {
  if (rt(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (rt(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function da(e) {
  var t = ca(e, "string");
  return rt(t) == "symbol" ? t : t + "";
}
function Ce(e, t, r) {
  return (t = da(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function vr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vr(Object(r), !0).forEach(function(n) {
      Ce(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vr(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function fa(e) {
  if (Array.isArray(e)) return Gt(e);
}
function ga(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Rr(e, t) {
  if (e) {
    if (typeof e == "string") return Gt(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Gt(e, t) : void 0;
  }
}
function ma() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $e(e) {
  return fa(e) || ga(e) || Rr(e) || ma();
}
function ha(e) {
  if (Array.isArray(e)) return e;
}
function va(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, o, s, u = [], f = !0, b = !1;
    try {
      if (o = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        f = !1;
      } else for (; !(f = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); f = !0) ;
    } catch (h) {
      b = !0, i = h;
    } finally {
      try {
        if (!f && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (b) throw i;
      }
    }
    return u;
  }
}
function ya() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function se(e, t) {
  return ha(e) || va(e, t) || Rr(e, t) || ya();
}
var $t = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var yr;
function ba() {
  return yr || (yr = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var o = "", s = 0; s < arguments.length; s++) {
          var u = arguments[s];
          u && (o = i(o, n(u)));
        }
        return o;
      }
      function n(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return r.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var s = "";
        for (var u in o)
          t.call(o, u) && o[u] && (s = i(s, u));
        return s;
      }
      function i(o, s) {
        return s ? o ? o + " " + s : o + s : o;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }($t)), $t.exports;
}
var pa = ba();
const qe = /* @__PURE__ */ Xr(pa);
function mt(e) {
  var t = g.useRef();
  t.current = e;
  var r = g.useCallback(function() {
    for (var n, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(o));
  }, []);
  return r;
}
function xa() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var br = process.env.NODE_ENV !== "test" && xa() ? g.useLayoutEffect : g.useEffect, Fr = function(t, r) {
  var n = g.useRef(!0);
  br(function() {
    return t(n.current);
  }, r), br(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, pr = function(t, r) {
  Fr(function(n) {
    if (!n)
      return t();
  }, r);
};
function xr(e) {
  var t = g.useRef(!1), r = g.useState(e), n = se(r, 2), i = n[0], o = n[1];
  g.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function s(u, f) {
    f && t.current || o(u);
  }
  return [i, s];
}
function qt(e) {
  return e !== void 0;
}
function wa(e, t) {
  var r = t, n = r.defaultValue, i = r.value, o = r.onChange, s = r.postState, u = xr(function() {
    return qt(i) ? i : qt(n) ? typeof n == "function" ? n() : n : typeof e == "function" ? e() : e;
  }), f = se(u, 2), b = f[0], h = f[1], E = i !== void 0 ? i : b, k = s ? s(E) : E, S = mt(o), M = xr([E]), x = se(M, 2), v = x[0], C = x[1];
  pr(function() {
    var _ = v[0];
    b !== _ && S(b, _);
  }, [v]), pr(function() {
    qt(i) || h(i);
  }, [i]);
  var d = mt(function(_, j) {
    h(_, j), C([E], j);
  });
  return [k, d];
}
var Xt = {}, Jt = [], Ea = function(t) {
  Jt.push(t);
};
function Tr(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = Jt.reduce(function(n, i) {
      return i(n ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function Ca(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = Jt.reduce(function(n, i) {
      return i(n ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function Sa() {
  Xt = {};
}
function Dr(e, t, r) {
  !t && !Xt[r] && (e(!1, r), Xt[r] = !0);
}
function ot(e, t) {
  Dr(Tr, e, t);
}
function Ma(e, t) {
  Dr(Ca, e, t);
}
ot.preMessage = Ea;
ot.resetWarned = Sa;
ot.noteOnce = Ma;
function ka(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = /* @__PURE__ */ new Set();
  function i(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, f = n.has(o);
    if (ot(!f, "Warning: There may be circular references"), f)
      return !1;
    if (o === s)
      return !0;
    if (r && u > 1)
      return !1;
    n.add(o);
    var b = u + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(s) || o.length !== s.length)
        return !1;
      for (var h = 0; h < o.length; h++)
        if (!i(o[h], s[h], b))
          return !1;
      return !0;
    }
    if (o && s && rt(o) === "object" && rt(s) === "object") {
      var E = Object.keys(o);
      return E.length !== Object.keys(s).length ? !1 : E.every(function(k) {
        return i(o[k], s[k], b);
      });
    }
    return !1;
  }
  return i(e, t);
}
function St() {
  return St = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, St.apply(null, arguments);
}
function Oa(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
function Pr(e, t) {
  if (e == null) return {};
  var r, n, i = Oa(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) r = o[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Kt(e, t, r) {
  return (e - t) / (r - t);
}
function zt(e, t, r, n) {
  var i = Kt(t, r, n), o = {};
  switch (e) {
    case "rtl":
      o.right = "".concat(i * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(i * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(i * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(i * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function it(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var p = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var r = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    r >= p.F1 && r <= p.F12)
      return !1;
    switch (r) {
      case p.ALT:
      case p.CAPS_LOCK:
      case p.CONTEXT_MENU:
      case p.CTRL:
      case p.DOWN:
      case p.END:
      case p.ESC:
      case p.HOME:
      case p.INSERT:
      case p.LEFT:
      case p.MAC_FF_META:
      case p.META:
      case p.NUMLOCK:
      case p.NUM_CENTER:
      case p.PAGE_DOWN:
      case p.PAGE_UP:
      case p.PAUSE:
      case p.PRINT_SCREEN:
      case p.RIGHT:
      case p.SHIFT:
      case p.UP:
      case p.WIN_KEY:
      case p.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= p.ZERO && t <= p.NINE || t >= p.NUM_ZERO && t <= p.NUM_MULTIPLY || t >= p.A && t <= p.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case p.SPACE:
      case p.QUESTION_MARK:
      case p.NUM_PLUS:
      case p.NUM_MINUS:
      case p.NUM_PERIOD:
      case p.NUM_DIVISION:
      case p.SEMICOLON:
      case p.DASH:
      case p.EQUALS:
      case p.COMMA:
      case p.PERIOD:
      case p.SLASH:
      case p.APOSTROPHE:
      case p.SINGLE_QUOTE:
      case p.OPEN_SQUARE_BRACKET:
      case p.BACKSLASH:
      case p.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, st = /* @__PURE__ */ g.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), _a = /* @__PURE__ */ g.createContext({}), Ra = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], Qt = /* @__PURE__ */ g.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.value, i = e.valueIndex, o = e.onStartMove, s = e.onDelete, u = e.style, f = e.render, b = e.dragging, h = e.draggingDelete, E = e.onOffsetChange, k = e.onChangeComplete, S = e.onFocus, M = e.onMouseEnter, x = Pr(e, Ra), v = g.useContext(st), C = v.min, d = v.max, _ = v.direction, j = v.disabled, I = v.keyboard, X = v.range, ne = v.tabIndex, le = v.ariaLabelForHandle, B = v.ariaLabelledByForHandle, N = v.ariaRequired, F = v.ariaValueTextFormatterForHandle, P = v.styles, U = v.classNames, K = "".concat(r, "-handle"), Q = function($) {
    j || o($, i);
  }, ce = function($) {
    S == null || S($, i);
  }, z = function($) {
    M($, i);
  }, Se = function($) {
    if (!j && I) {
      var A = null;
      switch ($.which || $.keyCode) {
        case p.LEFT:
          A = _ === "ltr" || _ === "btt" ? -1 : 1;
          break;
        case p.RIGHT:
          A = _ === "ltr" || _ === "btt" ? 1 : -1;
          break;
        // Up is plus
        case p.UP:
          A = _ !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case p.DOWN:
          A = _ !== "ttb" ? -1 : 1;
          break;
        case p.HOME:
          A = "min";
          break;
        case p.END:
          A = "max";
          break;
        case p.PAGE_UP:
          A = 2;
          break;
        case p.PAGE_DOWN:
          A = -2;
          break;
        case p.BACKSPACE:
        case p.DELETE:
          s(i);
          break;
      }
      A !== null && ($.preventDefault(), E(A, i));
    }
  }, xe = function($) {
    switch ($.which || $.keyCode) {
      case p.LEFT:
      case p.RIGHT:
      case p.UP:
      case p.DOWN:
      case p.HOME:
      case p.END:
      case p.PAGE_UP:
      case p.PAGE_DOWN:
        k == null || k();
        break;
    }
  }, Fe = zt(_, n, C, d), Me = {};
  if (i !== null) {
    var Te;
    Me = {
      tabIndex: j ? null : it(ne, i),
      role: "slider",
      "aria-valuemin": C,
      "aria-valuemax": d,
      "aria-valuenow": n,
      "aria-disabled": j,
      "aria-label": it(le, i),
      "aria-labelledby": it(B, i),
      "aria-required": it(N, i),
      "aria-valuetext": (Te = it(F, i)) === null || Te === void 0 ? void 0 : Te(n),
      "aria-orientation": _ === "ltr" || _ === "rtl" ? "horizontal" : "vertical",
      onMouseDown: Q,
      onTouchStart: Q,
      onFocus: ce,
      onMouseEnter: z,
      onKeyDown: Se,
      onKeyUp: xe
    };
  }
  var De = /* @__PURE__ */ g.createElement("div", St({
    ref: t,
    className: qe(K, Ce(Ce(Ce({}, "".concat(K, "-").concat(i + 1), i !== null && X), "".concat(K, "-dragging"), b), "".concat(K, "-dragging-delete"), h), U.handle),
    style: fe(fe(fe({}, Fe), u), P.handle)
  }, Me, x));
  return f && (De = f(De, {
    index: i,
    prefixCls: r,
    value: n,
    dragging: b,
    draggingDelete: h
  })), De;
});
process.env.NODE_ENV !== "production" && (Qt.displayName = "Handle");
var Fa = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], jr = /* @__PURE__ */ g.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.style, i = e.onStartMove, o = e.onOffsetChange, s = e.values, u = e.handleRender, f = e.activeHandleRender, b = e.draggingIndex, h = e.draggingDelete, E = e.onFocus, k = Pr(e, Fa), S = g.useRef({}), M = g.useState(!1), x = se(M, 2), v = x[0], C = x[1], d = g.useState(-1), _ = se(d, 2), j = _[0], I = _[1], X = function(F) {
    I(F), C(!0);
  }, ne = function(F, P) {
    X(P), E == null || E(F);
  }, le = function(F, P) {
    X(P);
  };
  g.useImperativeHandle(t, function() {
    return {
      focus: function(F) {
        var P;
        (P = S.current[F]) === null || P === void 0 || P.focus();
      },
      hideHelp: function() {
        Gr(function() {
          C(!1);
        });
      }
    };
  });
  var B = fe({
    prefixCls: r,
    onStartMove: i,
    onOffsetChange: o,
    render: u,
    onFocus: ne,
    onMouseEnter: le
  }, k);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, s.map(function(N, F) {
    var P = b === F;
    return /* @__PURE__ */ g.createElement(Qt, St({
      ref: function(K) {
        K ? S.current[F] = K : delete S.current[F];
      },
      dragging: P,
      draggingDelete: P && h,
      style: it(n, F),
      key: F,
      value: N,
      valueIndex: F
    }, B));
  }), f && v && /* @__PURE__ */ g.createElement(Qt, St({
    key: "a11y"
  }, B, {
    value: s[j],
    valueIndex: null,
    dragging: b !== -1,
    draggingDelete: h,
    render: f,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (jr.displayName = "Handles");
var Ta = function(t) {
  var r = t.prefixCls, n = t.style, i = t.children, o = t.value, s = t.onClick, u = g.useContext(st), f = u.min, b = u.max, h = u.direction, E = u.includedStart, k = u.includedEnd, S = u.included, M = "".concat(r, "-text"), x = zt(h, o, f, b);
  return /* @__PURE__ */ g.createElement("span", {
    className: qe(M, Ce({}, "".concat(M, "-active"), S && E <= o && o <= k)),
    style: fe(fe({}, x), n),
    onMouseDown: function(C) {
      C.stopPropagation();
    },
    onClick: function() {
      s(o);
    }
  }, i);
}, Da = function(t) {
  var r = t.prefixCls, n = t.marks, i = t.onClick, o = "".concat(r, "-mark");
  return n.length ? /* @__PURE__ */ g.createElement("div", {
    className: o
  }, n.map(function(s) {
    var u = s.value, f = s.style, b = s.label;
    return /* @__PURE__ */ g.createElement(Ta, {
      key: u,
      prefixCls: o,
      style: f,
      value: u,
      onClick: i
    }, b);
  })) : null;
}, Pa = function(t) {
  var r = t.prefixCls, n = t.value, i = t.style, o = t.activeStyle, s = g.useContext(st), u = s.min, f = s.max, b = s.direction, h = s.included, E = s.includedStart, k = s.includedEnd, S = "".concat(r, "-dot"), M = h && E <= n && n <= k, x = fe(fe({}, zt(b, n, u, f)), typeof i == "function" ? i(n) : i);
  return M && (x = fe(fe({}, x), typeof o == "function" ? o(n) : o)), /* @__PURE__ */ g.createElement("span", {
    className: qe(S, Ce({}, "".concat(S, "-active"), M)),
    style: x
  });
}, ja = function(t) {
  var r = t.prefixCls, n = t.marks, i = t.dots, o = t.style, s = t.activeStyle, u = g.useContext(st), f = u.min, b = u.max, h = u.step, E = g.useMemo(function() {
    var k = /* @__PURE__ */ new Set();
    if (n.forEach(function(M) {
      k.add(M.value);
    }), i && h !== null)
      for (var S = f; S <= b; )
        k.add(S), S += h;
    return Array.from(k);
  }, [f, b, h, i, n]);
  return /* @__PURE__ */ g.createElement("div", {
    className: "".concat(r, "-step")
  }, E.map(function(k) {
    return /* @__PURE__ */ g.createElement(Pa, {
      prefixCls: r,
      key: k,
      value: k,
      style: o,
      activeStyle: s
    });
  }));
}, wr = function(t) {
  var r = t.prefixCls, n = t.style, i = t.start, o = t.end, s = t.index, u = t.onStartMove, f = t.replaceCls, b = g.useContext(st), h = b.direction, E = b.min, k = b.max, S = b.disabled, M = b.range, x = b.classNames, v = "".concat(r, "-track"), C = Kt(i, E, k), d = Kt(o, E, k), _ = function(ne) {
    !S && u && u(ne, -1);
  }, j = {};
  switch (h) {
    case "rtl":
      j.right = "".concat(C * 100, "%"), j.width = "".concat(d * 100 - C * 100, "%");
      break;
    case "btt":
      j.bottom = "".concat(C * 100, "%"), j.height = "".concat(d * 100 - C * 100, "%");
      break;
    case "ttb":
      j.top = "".concat(C * 100, "%"), j.height = "".concat(d * 100 - C * 100, "%");
      break;
    default:
      j.left = "".concat(C * 100, "%"), j.width = "".concat(d * 100 - C * 100, "%");
  }
  var I = f || qe(v, Ce(Ce({}, "".concat(v, "-").concat(s + 1), s !== null && M), "".concat(r, "-track-draggable"), u), x.track);
  return /* @__PURE__ */ g.createElement("div", {
    className: I,
    style: fe(fe({}, j), n),
    onMouseDown: _,
    onTouchStart: _
  });
}, Na = function(t) {
  var r = t.prefixCls, n = t.style, i = t.values, o = t.startPoint, s = t.onStartMove, u = g.useContext(st), f = u.included, b = u.range, h = u.min, E = u.styles, k = u.classNames, S = g.useMemo(function() {
    if (!b) {
      if (i.length === 0)
        return [];
      var x = o ?? h, v = i[0];
      return [{
        start: Math.min(x, v),
        end: Math.max(x, v)
      }];
    }
    for (var C = [], d = 0; d < i.length - 1; d += 1)
      C.push({
        start: i[d],
        end: i[d + 1]
      });
    return C;
  }, [i, b, o, h]);
  if (!f)
    return null;
  var M = S != null && S.length && (k.tracks || E.tracks) ? /* @__PURE__ */ g.createElement(wr, {
    index: null,
    prefixCls: r,
    start: S[0].start,
    end: S[S.length - 1].end,
    replaceCls: qe(k.tracks, "".concat(r, "-tracks")),
    style: E.tracks
  }) : null;
  return /* @__PURE__ */ g.createElement(g.Fragment, null, M, S.map(function(x, v) {
    var C = x.start, d = x.end;
    return /* @__PURE__ */ g.createElement(wr, {
      index: v,
      prefixCls: r,
      style: fe(fe({}, it(n, v)), E.track),
      start: C,
      end: d,
      key: v,
      onStartMove: s
    });
  }));
}, Aa = 130;
function Er(e) {
  var t = "targetTouches" in e ? e.targetTouches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function La(e, t, r, n, i, o, s, u, f, b, h) {
  var E = g.useState(null), k = se(E, 2), S = k[0], M = k[1], x = g.useState(-1), v = se(x, 2), C = v[0], d = v[1], _ = g.useState(!1), j = se(_, 2), I = j[0], X = j[1], ne = g.useState(r), le = se(ne, 2), B = le[0], N = le[1], F = g.useState(r), P = se(F, 2), U = P[0], K = P[1], Q = g.useRef(null), ce = g.useRef(null), z = g.useRef(null), Se = g.useContext(_a), xe = Se.onDragStart, Fe = Se.onDragChange;
  Fr(function() {
    C === -1 && N(r);
  }, [r, C]), g.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", Q.current), document.removeEventListener("mouseup", ce.current), z.current && (z.current.removeEventListener("touchmove", Q.current), z.current.removeEventListener("touchend", ce.current));
    };
  }, []);
  var Me = function(A, Z, te) {
    Z !== void 0 && M(Z), N(A);
    var ae = A;
    te && (ae = A.filter(function(V, de) {
      return de !== C;
    })), s(ae), Fe && Fe({
      rawValues: A,
      deleteIndex: te ? C : -1,
      draggingIndex: C,
      draggingValue: Z
    });
  }, Te = mt(function($, A, Z) {
    if ($ === -1) {
      var te = U[0], ae = U[U.length - 1], V = n - te, de = i - ae, ye = A * (i - n);
      ye = Math.max(ye, V), ye = Math.min(ye, de);
      var Ge = o(te + ye);
      ye = Ge - te;
      var ke = U.map(function(we) {
        return we + ye;
      });
      Me(ke);
    } else {
      var be = (i - n) * A, ge = $e(B);
      ge[$] = U[$];
      var Oe = f(ge, be, $, "dist");
      Me(Oe.values, Oe.value, Z);
    }
  }), De = function(A, Z, te) {
    A.stopPropagation();
    var ae = te || r, V = ae[Z];
    d(Z), M(V), K(ae), N(ae), X(!1);
    var de = Er(A), ye = de.pageX, Ge = de.pageY, ke = !1;
    xe && xe({
      rawValues: ae,
      draggingIndex: Z,
      draggingValue: V
    });
    var be = function(we) {
      we.preventDefault();
      var ie = Er(we), Xe = ie.pageX, Ke = ie.pageY, je = Xe - ye, Ee = Ke - Ge, pe = e.current.getBoundingClientRect(), Ne = pe.width, Le = pe.height, _e, Ae;
      switch (t) {
        case "btt":
          _e = -Ee / Le, Ae = je;
          break;
        case "ttb":
          _e = Ee / Le, Ae = je;
          break;
        case "rtl":
          _e = -je / Ne, Ae = Ee;
          break;
        default:
          _e = je / Ne, Ae = Ee;
      }
      ke = b ? Math.abs(Ae) > Aa && h < B.length : !1, X(ke), Te(Z, _e, ke);
    }, ge = function Oe(we) {
      we.preventDefault(), document.removeEventListener("mouseup", Oe), document.removeEventListener("mousemove", be), z.current && (z.current.removeEventListener("touchmove", Q.current), z.current.removeEventListener("touchend", ce.current)), Q.current = null, ce.current = null, z.current = null, u(ke), d(-1), X(!1);
    };
    document.addEventListener("mouseup", ge), document.addEventListener("mousemove", be), A.currentTarget.addEventListener("touchend", ge), A.currentTarget.addEventListener("touchmove", be), Q.current = be, ce.current = ge, z.current = A.currentTarget;
  }, Pe = g.useMemo(function() {
    var $ = $e(r).sort(function(V, de) {
      return V - de;
    }), A = $e(B).sort(function(V, de) {
      return V - de;
    }), Z = {};
    A.forEach(function(V) {
      Z[V] = (Z[V] || 0) + 1;
    }), $.forEach(function(V) {
      Z[V] = (Z[V] || 0) - 1;
    });
    var te = b ? 1 : 0, ae = Object.values(Z).reduce(function(V, de) {
      return V + Math.abs(de);
    }, 0);
    return ae <= te ? B : r;
  }, [r, B, b]);
  return [C, S, I, Pe, De];
}
function Ha(e, t, r, n, i, o) {
  var s = g.useCallback(function(S) {
    return Math.max(e, Math.min(t, S));
  }, [e, t]), u = g.useCallback(function(S) {
    if (r !== null) {
      var M = e + Math.round((s(S) - e) / r) * r, x = function(_) {
        return (String(_).split(".")[1] || "").length;
      }, v = Math.max(x(r), x(t), x(e)), C = Number(M.toFixed(v));
      return e <= C && C <= t ? C : null;
    }
    return null;
  }, [r, e, t, s]), f = g.useCallback(function(S) {
    var M = s(S), x = n.map(function(d) {
      return d.value;
    });
    r !== null && x.push(u(S)), x.push(e, t);
    var v = x[0], C = t - e;
    return x.forEach(function(d) {
      var _ = Math.abs(M - d);
      _ <= C && (v = d, C = _);
    }), v;
  }, [e, t, n, r, s, u]), b = function S(M, x, v) {
    var C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof x == "number") {
      var d, _ = M[v], j = _ + x, I = [];
      n.forEach(function(N) {
        I.push(N.value);
      }), I.push(e, t), I.push(u(_));
      var X = x > 0 ? 1 : -1;
      C === "unit" ? I.push(u(_ + X * r)) : I.push(u(j)), I = I.filter(function(N) {
        return N !== null;
      }).filter(function(N) {
        return x < 0 ? N <= _ : N >= _;
      }), C === "unit" && (I = I.filter(function(N) {
        return N !== _;
      }));
      var ne = C === "unit" ? _ : j;
      d = I[0];
      var le = Math.abs(d - ne);
      if (I.forEach(function(N) {
        var F = Math.abs(N - ne);
        F < le && (d = N, le = F);
      }), d === void 0)
        return x < 0 ? e : t;
      if (C === "dist")
        return d;
      if (Math.abs(x) > 1) {
        var B = $e(M);
        return B[v] = d, S(B, x - X, v, C);
      }
      return d;
    } else {
      if (x === "min")
        return e;
      if (x === "max")
        return t;
    }
  }, h = function(M, x, v) {
    var C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", d = M[v], _ = b(M, x, v, C);
    return {
      value: _,
      changed: _ !== d
    };
  }, E = function(M) {
    return o === null && M === 0 || typeof o == "number" && M < o;
  }, k = function(M, x, v) {
    var C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", d = M.map(f), _ = d[v], j = b(d, x, v, C);
    if (d[v] = j, i === !1) {
      var I = o || 0;
      v > 0 && d[v - 1] !== _ && (d[v] = Math.max(d[v], d[v - 1] + I)), v < d.length - 1 && d[v + 1] !== _ && (d[v] = Math.min(d[v], d[v + 1] - I));
    } else if (typeof o == "number" || o === null) {
      for (var X = v + 1; X < d.length; X += 1)
        for (var ne = !0; E(d[X] - d[X - 1]) && ne; ) {
          var le = h(d, 1, X);
          d[X] = le.value, ne = le.changed;
        }
      for (var B = v; B > 0; B -= 1)
        for (var N = !0; E(d[B] - d[B - 1]) && N; ) {
          var F = h(d, -1, B - 1);
          d[B - 1] = F.value, N = F.changed;
        }
      for (var P = d.length - 1; P > 0; P -= 1)
        for (var U = !0; E(d[P] - d[P - 1]) && U; ) {
          var K = h(d, -1, P - 1);
          d[P - 1] = K.value, U = K.changed;
        }
      for (var Q = 0; Q < d.length - 1; Q += 1)
        for (var ce = !0; E(d[Q + 1] - d[Q]) && ce; ) {
          var z = h(d, 1, Q + 1);
          d[Q + 1] = z.value, ce = z.changed;
        }
    }
    return {
      value: d[v],
      values: d
    };
  };
  return [f, k];
}
function Wa(e) {
  return Lr(function() {
    if (e === !0 || !e)
      return [!!e, !1, !1, 0];
    var t = e.editable, r = e.draggableTrack, n = e.minCount, i = e.maxCount;
    return process.env.NODE_ENV !== "production" && Tr(!t || !r, "`editable` can not work with `draggableTrack`."), [!0, t, !t && r, n || 0, i];
  }, [e]);
}
var Nr = /* @__PURE__ */ g.forwardRef(function(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-slider" : r, i = e.className, o = e.style, s = e.classNames, u = e.styles, f = e.id, b = e.disabled, h = b === void 0 ? !1 : b, E = e.keyboard, k = E === void 0 ? !0 : E, S = e.autoFocus, M = e.onFocus, x = e.onBlur, v = e.min, C = v === void 0 ? 0 : v, d = e.max, _ = d === void 0 ? 100 : d, j = e.step, I = j === void 0 ? 1 : j, X = e.value, ne = e.defaultValue, le = e.range, B = e.count, N = e.onChange, F = e.onBeforeChange, P = e.onAfterChange, U = e.onChangeComplete, K = e.allowCross, Q = K === void 0 ? !0 : K, ce = e.pushable, z = ce === void 0 ? !1 : ce, Se = e.reverse, xe = e.vertical, Fe = e.included, Me = Fe === void 0 ? !0 : Fe, Te = e.startPoint, De = e.trackStyle, Pe = e.handleStyle, $ = e.railStyle, A = e.dotStyle, Z = e.activeDotStyle, te = e.marks, ae = e.dots, V = e.handleRender, de = e.activeHandleRender, ye = e.track, Ge = e.tabIndex, ke = Ge === void 0 ? 0 : Ge, be = e.ariaLabelForHandle, ge = e.ariaLabelledByForHandle, Oe = e.ariaRequired, we = e.ariaValueTextFormatterForHandle, ie = g.useRef(null), Xe = g.useRef(null), Ke = g.useMemo(function() {
    return xe ? Se ? "ttb" : "btt" : Se ? "rtl" : "ltr";
  }, [Se, xe]), je = Wa(le), Ee = se(je, 5), pe = Ee[0], Ne = Ee[1], Le = Ee[2], _e = Ee[3], Ae = Ee[4], me = g.useMemo(function() {
    return isFinite(C) ? C : 0;
  }, [C]), He = g.useMemo(function() {
    return isFinite(_) ? _ : 100;
  }, [_]), We = g.useMemo(function() {
    return I !== null && I <= 0 ? 1 : I;
  }, [I]), Lt = g.useMemo(function() {
    return typeof z == "boolean" ? z ? We : !1 : z >= 0 ? z : !1;
  }, [z, We]), ut = g.useMemo(function() {
    return Object.keys(te || {}).map(function(D) {
      var w = te[D], H = {
        value: Number(D)
      };
      return w && rt(w) === "object" && !/* @__PURE__ */ g.isValidElement(w) && ("label" in w || "style" in w) ? (H.style = w.style, H.label = w.label) : H.label = w, H;
    }).filter(function(D) {
      var w = D.label;
      return w || typeof w == "number";
    }).sort(function(D, w) {
      return D.value - w.value;
    });
  }, [te]), Ht = Ha(me, He, We, ut, Q, Lt), Mt = se(Ht, 2), lt = Mt[0], kt = Mt[1], ht = wa(ne, {
    value: X
  }), vt = se(ht, 2), he = vt[0], yt = vt[1], re = g.useMemo(function() {
    var D = he == null ? [] : Array.isArray(he) ? he : [he], w = se(D, 1), H = w[0], q = H === void 0 ? me : H, ee = he === null ? [] : [q];
    if (pe) {
      if (ee = $e(D), B || he === void 0) {
        var ze = B >= 0 ? B + 1 : 2;
        for (ee = ee.slice(0, ze); ee.length < ze; ) {
          var Be;
          ee.push((Be = ee[ee.length - 1]) !== null && Be !== void 0 ? Be : me);
        }
      }
      ee.sort(function(Ye, Ue) {
        return Ye - Ue;
      });
    }
    return ee.forEach(function(Ye, Ue) {
      ee[Ue] = lt(Ye);
    }), ee;
  }, [he, pe, me, B, lt]), Ie = function(w) {
    return pe ? w : w[0];
  }, ct = mt(function(D) {
    var w = $e(D).sort(function(H, q) {
      return H - q;
    });
    N && !ka(w, re, !0) && N(Ie(w)), yt(w);
  }), bt = mt(function(D) {
    D && ie.current.hideHelp();
    var w = Ie(re);
    P == null || P(w), ot(!P, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), U == null || U(w);
  }), Wt = function(w) {
    if (!(h || !Ne || re.length <= _e)) {
      var H = $e(re);
      H.splice(w, 1), F == null || F(Ie(H)), ct(H);
      var q = Math.max(0, w - 1);
      ie.current.hideHelp(), ie.current.focus(q);
    }
  }, Ot = La(Xe, Ke, re, me, He, lt, ct, bt, kt, Ne, _e), Qe = se(Ot, 5), _t = Qe[0], It = Qe[1], Rt = Qe[2], dt = Qe[3], Ft = Qe[4], Tt = function(w, H) {
    if (!h) {
      var q = $e(re), ee = 0, ze = 0, Be = He - me;
      re.forEach(function(Ze, Dt) {
        var Zt = Math.abs(w - Ze);
        Zt <= Be && (Be = Zt, ee = Dt), Ze < w && (ze = Dt);
      });
      var Ye = ee;
      Ne && Be !== 0 && (!Ae || re.length < Ae) ? (q.splice(ze + 1, 0, w), Ye = ze + 1) : q[ee] = w, pe && !re.length && B === void 0 && q.push(w);
      var Ue = Ie(q);
      if (F == null || F(Ue), ct(q), H) {
        var nt, ft;
        (nt = document.activeElement) === null || nt === void 0 || (ft = nt.blur) === null || ft === void 0 || ft.call(nt), ie.current.focus(Ye), Ft(H, Ye, q);
      } else
        P == null || P(Ue), ot(!P, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), U == null || U(Ue);
    }
  }, Bt = function(w) {
    w.preventDefault();
    var H = Xe.current.getBoundingClientRect(), q = H.width, ee = H.height, ze = H.left, Be = H.top, Ye = H.bottom, Ue = H.right, nt = w.clientX, ft = w.clientY, Ze;
    switch (Ke) {
      case "btt":
        Ze = (Ye - ft) / ee;
        break;
      case "ttb":
        Ze = (ft - Be) / ee;
        break;
      case "rtl":
        Ze = (Ue - nt) / q;
        break;
      default:
        Ze = (nt - ze) / q;
    }
    var Dt = me + Ze * (He - me);
    Tt(lt(Dt), w);
  }, Yt = g.useState(null), a = se(Yt, 2), c = a[0], y = a[1], O = function(w, H) {
    if (!h) {
      var q = kt(re, w, H);
      F == null || F(Ie(re)), ct(q.values), y(q.value);
    }
  };
  g.useEffect(function() {
    if (c !== null) {
      var D = re.indexOf(c);
      D >= 0 && ie.current.focus(D);
    }
    y(null);
  }, [c]);
  var L = g.useMemo(function() {
    return Le && We === null ? (process.env.NODE_ENV !== "production" && ot(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : Le;
  }, [Le, We]), W = mt(function(D, w) {
    Ft(D, w), F == null || F(Ie(re));
  }), T = _t !== -1;
  g.useEffect(function() {
    if (!T) {
      var D = re.lastIndexOf(It);
      ie.current.focus(D);
    }
  }, [T]);
  var R = g.useMemo(function() {
    return $e(dt).sort(function(D, w) {
      return D - w;
    });
  }, [dt]), oe = g.useMemo(function() {
    return pe ? [R[0], R[R.length - 1]] : [me, R[0]];
  }, [R, pe, me]), G = se(oe, 2), J = G[0], ve = G[1];
  g.useImperativeHandle(t, function() {
    return {
      focus: function() {
        ie.current.focus(0);
      },
      blur: function() {
        var w, H = document, q = H.activeElement;
        (w = Xe.current) !== null && w !== void 0 && w.contains(q) && (q == null || q.blur());
      }
    };
  }), g.useEffect(function() {
    S && ie.current.focus(0);
  }, []);
  var Je = g.useMemo(function() {
    return {
      min: me,
      max: He,
      direction: Ke,
      disabled: h,
      keyboard: k,
      step: We,
      included: Me,
      includedStart: J,
      includedEnd: ve,
      range: pe,
      tabIndex: ke,
      ariaLabelForHandle: be,
      ariaLabelledByForHandle: ge,
      ariaRequired: Oe,
      ariaValueTextFormatterForHandle: we,
      styles: u || {},
      classNames: s || {}
    };
  }, [me, He, Ke, h, k, We, Me, J, ve, pe, ke, be, ge, Oe, we, u, s]);
  return /* @__PURE__ */ g.createElement(st.Provider, {
    value: Je
  }, /* @__PURE__ */ g.createElement("div", {
    ref: Xe,
    className: qe(n, i, Ce(Ce(Ce(Ce({}, "".concat(n, "-disabled"), h), "".concat(n, "-vertical"), xe), "".concat(n, "-horizontal"), !xe), "".concat(n, "-with-marks"), ut.length)),
    style: o,
    onMouseDown: Bt,
    id: f
  }, /* @__PURE__ */ g.createElement("div", {
    className: qe("".concat(n, "-rail"), s == null ? void 0 : s.rail),
    style: fe(fe({}, $), u == null ? void 0 : u.rail)
  }), ye !== !1 && /* @__PURE__ */ g.createElement(Na, {
    prefixCls: n,
    style: De,
    values: re,
    startPoint: Te,
    onStartMove: L ? W : void 0
  }), /* @__PURE__ */ g.createElement(ja, {
    prefixCls: n,
    marks: ut,
    dots: ae,
    style: A,
    activeStyle: Z
  }), /* @__PURE__ */ g.createElement(jr, {
    ref: ie,
    prefixCls: n,
    style: Pe,
    values: dt,
    draggingIndex: _t,
    draggingDelete: Rt,
    onStartMove: W,
    onOffsetChange: O,
    onFocus: M,
    onBlur: x,
    handleRender: V,
    activeHandleRender: de,
    onChangeComplete: bt,
    onDelete: Ne ? Wt : void 0
  }), /* @__PURE__ */ g.createElement(Da, {
    prefixCls: n,
    marks: ut,
    onClick: Tt
  })));
});
process.env.NODE_ENV !== "production" && (Nr.displayName = "Slider");
const m = {
  grey: {
    0: "#FFF",
    10: "#F2F2F7",
    50: "#E5E5EA",
    100: "#D1D1D6",
    200: "#C7C7CC",
    300: "#AEAEB2",
    400: "#8E8E93",
    500: "#636366",
    600: "#48484A",
    700: "#3A3A3C",
    800: "#2C2C2E",
    900: "#242426",
    950: "#1C1C1E",
    1e3: "#000000"
  },
  "strong-blue": {
    50: "#B2D7FF",
    100: "#479FF8",
    300: "#3874CB",
    400: "#3461DA",
    900: "#173163",
    950: "#0B243E"
  },
  "signal-green": {
    300: "#14FF00"
  },
  "signal-orange": {
    300: "#FF5100"
  },
  "signal-pink": {
    300: "#FF0055"
  },
  "signal-purple": {
    300: "#FF65FF"
  },
  "signal-yellow": {
    300: "#FFEC45"
  },
  red: {
    10: "#FEF1F2",
    75: "#FF8680",
    100: "#FF6861",
    300: "#FF453A",
    400: "#FF3B2F",
    600: "#D70015",
    800: "#A10010"
  },
  orange: {
    100: "#FFB33F",
    300: "#FF9F0B",
    400: "#FF9500",
    600: "#C93400"
  },
  yellow: {
    10: "#FFF8EB",
    75: "#FFE372",
    100: "#FFD426",
    300: "#FED709",
    400: "#FFCC02",
    600: "#B25001",
    800: "#873C00"
  },
  green: {
    10: "#EDFDF8",
    75: "#7AF299",
    100: "#30DB5B",
    300: "#31D158",
    400: "#35C759",
    600: "#248A3D",
    800: "#0D5C20"
  },
  mint: {
    100: "#66D5CF",
    300: "#67D3CF",
    400: "#04C7BE",
    600: "#0D817C"
  },
  teal: {
    100: "#5DE6FF",
    300: "#40C8E0",
    400: "#30B0C7",
    600: "#008299"
  },
  cyan: {
    100: "#70D7FF",
    300: "#64D3FF",
    400: "#31ADE6",
    600: "#0171A4"
  },
  blue: {
    100: "#419CFF",
    300: "#0B84FF",
    400: "#007AFF",
    600: "#0040DD"
  },
  indigo: {
    100: "#7E7AFF",
    300: "#5E5CE6",
    400: "#5856D7",
    600: "#3634A3"
  },
  purple: {
    100: "#DA8FFF",
    300: "#BF5AF2",
    400: "#AF52DE",
    600: "#8944AB"
  },
  pink: {
    100: "#FF6482",
    300: "#FF375F",
    400: "#FF2C55",
    600: "#D20F44"
  },
  brown: {
    100: "#B59469",
    300: "#AC8E68",
    400: "#A2845E",
    600: "#7F6545"
  }
}, Vt = {
  background: {
    primary: m.grey[950],
    "primary-hover": m.grey[700],
    secondary: m.grey[800],
    "secondary-hover": m.grey[950],
    tertiary: m.grey[600],
    "tertiary-hover": m.grey[700]
  },
  label: {
    primary: m.grey[0],
    secondary: m.grey[200],
    tertiary: m.grey[400],
    placeholder: m.grey[400],
    quaternary: m.grey[1e3]
  },
  "primary-action": {
    graphical: m["strong-blue"][300],
    button: m["strong-blue"][100],
    background: m["strong-blue"][950],
    "background-2": m["strong-blue"][50],
    disabled: m.grey[700]
  },
  "secondary-action": {
    base: m.grey[0],
    complementary: m.grey[950],
    alternative: m.grey[600],
    disabled: m.grey[700]
  },
  brand: {
    green: m["signal-green"][300],
    orange: m["signal-orange"][300],
    pink: m["signal-pink"][300],
    purple: m["signal-purple"][300],
    yellow: m["signal-yellow"][300]
  },
  separator: {
    regular: m.grey[400],
    opaque: m.grey[600]
  },
  "system-fill": {
    primary: m.grey[600],
    secondary: m.grey[800],
    tertiary: m.grey[950]
  },
  success: {
    background: m.green[800],
    default: m.green[300],
    hover: m.green[75],
    accessible: m.green[10]
  },
  warning: {
    background: m.yellow[800],
    default: m.yellow[300],
    hover: m.yellow[75],
    accessible: m.yellow[10]
  },
  danger: {
    background: m.red[800],
    default: m.red[300],
    hover: m.red[75],
    accessible: m.red[10]
  },
  "system-neutral": {
    "grey-0": m.grey[1e3],
    "grey-1": m.grey[950],
    "grey-2": m.grey[900],
    "grey-3": m.grey[800],
    "grey-4": m.grey[700],
    "grey-5": m.grey[600],
    "grey-6": m.grey[500],
    "grey-7": m.grey[400],
    "grey-8": m.grey[300],
    "grey-9": m.grey[200],
    "grey-10": m.grey[100],
    "grey-11": m.grey[50],
    "grey-12": m.grey[10],
    "grey-13": m.grey[0]
  },
  red: {
    default: m.red[300],
    accessible: m.red[100]
  },
  orange: {
    default: m.orange[300],
    accessible: m.orange[100]
  },
  yellow: {
    default: m.yellow[300],
    accessible: m.yellow[100]
  },
  green: {
    default: m.green[300],
    accessible: m.green[100]
  },
  mint: {
    default: m.mint[300],
    accessible: m.mint[100]
  },
  teal: {
    default: m.teal[300],
    accessible: m.teal[100]
  },
  cyan: {
    default: m.cyan[300],
    accessible: m.cyan[100]
  },
  blue: {
    default: m.blue[300],
    accessible: m.blue[100]
  },
  indigo: {
    default: m.indigo[300],
    accessible: m.indigo[100]
  },
  purple: {
    default: m.purple[300],
    accessible: m.purple[100]
  },
  pink: {
    default: m.pink[300],
    accessible: m.pink[100]
  },
  brown: {
    default: m.brown[300],
    accessible: m.brown[100]
  }
}, Qa = () => {
}, Ve = ({
  variant: e = "B1",
  significance: t = "primary",
  as: r,
  children: n,
  className: i
}) => {
  const o = r ?? Ba[e], s = Ia[e];
  return /* @__PURE__ */ l.jsx(o, { className: qe(`text-label-${t}`, i, s), children: n });
}, Ia = {
  Di1: "font-sans text-[72px] font-bold leading-[90px] -tracking-2,5",
  Di2: "font-sans text-[60px] font-bold leading-[72px] -tracking-2,0",
  Di3: "font-sans text-[48px] font-bold leading-[60px] -tracking-1,5",
  T1: "font-sans text-[40px] font-bold leading-[48px] -tracking-1,5",
  T2: "font-sans text-[32px] font-bold leading-[40px] -tracking-1",
  T3: "font-sans text-[24px] font-bold leading-[32px] -tracking-0,5",
  H1: "font-sans text-[24px] font-bold leading-[32px] -tracking-0,5",
  H2: "font-sans text-[20px] font-bold leading-[24px]",
  H3: "font-sans text-[15px] font-bold leading-[20px]",
  H4: "font-sans text-[13px] font-bold leading-[16px]",
  B1B: "font-sans text-[15px] font-bold leading-[22px] -tracking-0,1",
  B1: "font-sans text-[15px] leading-[22px] -tracking-0,1",
  B1Button: "font-sans text-[15px] leading-[16px] -tracking-0,1",
  B2: "font-sans text-[13px] leading-[20px]",
  B2Button: "font-sans text-[13px] leading-[14px]",
  D1B: "font-sans text-[12px] font-bold leading-[16px]",
  D1: "font-sans text-[12px] leading-[16px]",
  M: "font-sans text-[10px] leading-[14px]"
}, Ba = {
  Di1: "h1",
  Di2: "h2",
  Di3: "h3",
  T1: "h1",
  T2: "h2",
  T3: "h3",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  B1B: "p",
  B1: "p",
  B1Button: "span",
  B2: "p",
  B2Button: "span",
  D1B: "p",
  D1: "p",
  M: "p"
}, Ja = ({ min: e, max: t, start: r, end: n, onChange: i }) => {
  const o = (/* @__PURE__ */ new Date()).getTime(), s = e.getTime(), u = t == null ? void 0 : t.getTime(), f = (b) => {
    if (!Array.isArray(b))
      return;
    const [h, E] = b, k = new Date(h), S = new Date(E);
    i(k, S);
  };
  return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "flex gap-1 items-center", children: [
        /* @__PURE__ */ l.jsx(rr, { weight: "bold", size: 16, className: "text-label-tertiary" }),
        /* @__PURE__ */ l.jsx(Ve, { variant: "B2", children: hr(r, "yyyy-MM-dd") })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex gap-1 items-center", children: [
        u ? u > o ? /* @__PURE__ */ l.jsx(Wr, { weight: "bold", size: 16, className: "text-danger-default" }) : /* @__PURE__ */ l.jsx(rr, { weight: "bold", size: 16, className: "text-label-tertiary" }) : /* @__PURE__ */ l.jsx(Hr, { weight: "fill", size: 16, className: "text-danger-default" }),
        /* @__PURE__ */ l.jsx(Ve, { variant: "B2", children: hr(n, "yyyy-MM-dd") })
      ] })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "flex px-2", children: /* @__PURE__ */ l.jsx(
      Nr,
      {
        range: !0,
        min: s,
        max: u ?? o,
        step: 24 * 60 * 60 * 1e3,
        defaultValue: [s, u ?? o],
        value: [r.getTime(), n.getTime()],
        onChange: f,
        styles: {
          rail: {
            backgroundColor: Vt["primary-action"].disabled,
            height: "8px",
            padding: "4px 0"
          },
          track: {
            backgroundColor: Vt.label.tertiary,
            height: "8px",
            padding: "4px 0"
          },
          handle: {
            backgroundColor: Vt.label.primary,
            border: "none",
            width: "16px",
            height: "16px",
            opacity: 1,
            boxShadow: "none",
            marginTop: "-4px"
          }
        }
      }
    ) })
  ] });
}, za = ({ first: e, last: t, current: r, onChange: n }) => {
  const i = "flex items-center justify-center w-8 h-8 rounded-lg", o = Array.from({ length: t - e + 1 }, (s, u) => u + e).filter(
    (s) => s === r || s === r - 1 || s === r + 1 || s === t - 2 && r === t || s === e + 2 && r === e
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "flex gap-2 py-3 items-center justify-between bg-background-primary text-label-primary", children: [
    /* @__PURE__ */ l.jsx(
      "button",
      {
        disabled: r === e,
        className: ue(i, { "opacity-50": r === e }),
        onClick: () => n(e),
        children: /* @__PURE__ */ l.jsx(Ir, {})
      }
    ),
    /* @__PURE__ */ l.jsx(
      "button",
      {
        disabled: r === e,
        className: ue(i, { "opacity-50": r === e }),
        onClick: () => n(r - 1),
        children: /* @__PURE__ */ l.jsx(Br, {})
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "flex gap-2 items-center", children: o.map((s) => /* @__PURE__ */ l.jsx(
      "button",
      {
        className: ue(i, {
          "bg-background-tertiary": r === s
        }),
        onClick: () => n(s),
        children: s
      },
      s
    )) }),
    /* @__PURE__ */ l.jsx(
      "button",
      {
        disabled: r === t,
        className: ue(i, { "opacity-50": r === t }),
        onClick: () => n(r + 1),
        children: /* @__PURE__ */ l.jsx(Yr, {})
      }
    ),
    /* @__PURE__ */ l.jsx(
      "button",
      {
        disabled: r === t,
        className: ue(i, { "opacity-50": r === t }),
        onClick: () => n(t),
        children: /* @__PURE__ */ l.jsx(Ur, {})
      }
    )
  ] });
}, Ya = ({
  selected: e,
  setSelected: t,
  children: r
}) => {
  const n = r[e];
  return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col min-h-0 grow", children: [
    /* @__PURE__ */ l.jsx("div", { className: "flex gap-3 p-3", children: r.map((i, o) => er(i) ? /* @__PURE__ */ l.jsx(
      "button",
      {
        className: ue("flex items-center justify-center p-2 rounded-lg", {
          "bg-background-tertiary": o === e
        }),
        onClick: () => t(o),
        children: /* @__PURE__ */ l.jsx(Ve, { variant: "B2", children: i.props.label })
      },
      o
    ) : null) }),
    /* @__PURE__ */ l.jsx(Ar, { opaque: !0 }),
    er(n) && /* @__PURE__ */ l.jsx("div", { className: "flex flex-col min-h-0 grow", children: n.props.children })
  ] });
};
Ya.Item = ({ children: e }) => /* @__PURE__ */ l.jsx("div", { children: e });
const Za = ({ options: e, onChange: t, selectedValue: r }) => /* @__PURE__ */ l.jsx("div", { className: "flex p-0.5 rounded-lg bg-background-secondary", children: e.map((n) => /* @__PURE__ */ l.jsx(
  "button",
  {
    onClick: () => t(n.value),
    className: ue("flex items-center justify-center w-7 h-7 rounded-md", {
      "text-label-primary bg-secondary-action-alternative": n.value === r,
      "text-label-placeholder": n.value !== r
    }),
    children: /* @__PURE__ */ l.jsx(
      Nt.Provider,
      {
        value: { size: 16, weight: n.value === r ? "fill" : "regular" },
        children: n.icon
      }
    )
  },
  n.value
)) }), ei = ({ size: e }) => /* @__PURE__ */ l.jsx("div", { className: "animate-spin", children: /* @__PURE__ */ l.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#paint0_angular_94_27062_clip_path)", children: /* @__PURE__ */ l.jsx("g", { transform: "matrix(0.008 0 0 0.008 8 8)", children: /* @__PURE__ */ l.jsx("foreignObject", { x: "-1125", y: "-1125", width: "2250", height: "2250", children: /* @__PURE__ */ l.jsx(
        "div",
        {
          style: {
            background: "conic-gradient(from 90deg, rgba(39, 174, 96, 0) 0deg, rgba(58, 225, 128, 0) 0.036deg, rgba(255, 255, 255, 1) 360deg)",
            height: "100%",
            width: "100%",
            opacity: 1
          }
        }
      ) }) }) }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.1878 6.40045C15.5529 6.35334 15.8871 6.61117 15.9343 6.97633C15.978 7.31579 16 7.65771 16 7.99999C16 8.36818 15.7015 8.66665 15.3333 8.66665C14.9652 8.66665 14.6667 8.36818 14.6667 7.99999C14.6667 7.71476 14.6484 7.42983 14.6119 7.14694C14.5648 6.78178 14.8226 6.44756 15.1878 6.40045Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "paint0_angular_94_27062_clip_path", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z"
        }
      ) }) })
    ]
  }
) }), Ua = ({ width: e, height: t }) => {
  const i = 2.1914893617021276;
  return t ? e = t * i : e ? t = e / i : (t = 235, e = 515), /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 515 235",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M143.755 60H159.741L118.224 175H101.546L60 60H76.0009L109.835 156.184L143.755 60Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M168.201 175H151.897L197.882 60H213.497L259.483 175H243.164L205.683 74.5151L168.201 175Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M359.224 175L306.652 116.982L355.962 60H336.89L290.982 113.605V60H275.173V175H290.982V120.12L339.288 175H359.224Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M401.834 162.054H450V175H386.121V60H449.473V72.9599H401.834V162.054Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M60 123.463L65.5964 137.703L428.403 112.351L434.311 97.2971L60 123.463Z",
            fill: "url(#paint0_linear_3_3228)"
          }
        ),
        /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_3_3228",
            x1: "450",
            y1: "60.0002",
            x2: "157.509",
            y2: "295.901",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l.jsx("stop", { offset: "0.0819693", stopColor: "#3324E9" }),
              /* @__PURE__ */ l.jsx("stop", { offset: "0.372992", stopColor: "#C75BBA" }),
              /* @__PURE__ */ l.jsx("stop", { offset: "0.478198", stopColor: "#E756A5" }),
              /* @__PURE__ */ l.jsx("stop", { offset: "0.669573", stopColor: "#D96DB7" }),
              /* @__PURE__ */ l.jsx("stop", { offset: "1", stopColor: "#1CFFFF" })
            ]
          }
        ) })
      ]
    }
  );
}, $a = ({ children: e }) => /* @__PURE__ */ l.jsx("div", { className: "relative", children: /* @__PURE__ */ l.jsx("div", { className: "absolute left-0 top-1 shadow-lg px-4 py-5 border rounded-lg bg-background-primary border-separator-regular", children: e }) }), ti = ({ isOpen: e, tooglePopup: t, children: r }) => e ? /* @__PURE__ */ l.jsxs("div", { className: "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-background-secondary p-8 rounded-xl shadow-2xl max-w-md w-11/12", children: [
  /* @__PURE__ */ l.jsx("button", { className: "absolute top-4 right-4", onClick: t, children: /* @__PURE__ */ l.jsx(Sr, { size: 16, className: "text-label-primary", weight: "bold" }) }),
  r
] }) : null, Ar = ({ className: e, vertical: t = !1, opaque: r = !1 }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ue(
      {
        "w-full h-px": !t,
        "h-full w-px": t,
        "bg-separator-opaque": r,
        "bg-separator-regular": !r
      },
      e
    )
  }
), qa = ({ children: e, variant: t = "neutral", size: r = "small", subtle: n, count: i }) => {
  const o = () => {
    switch (t) {
      case "neutral":
        return n ? "border border-system-fill-primary" : "border border-system-fill-primary bg-system-fill-primary";
      case "warning":
        return n ? "border border-warning-default" : "border border-warning-default bg-warning-default";
      case "aggregated":
        return "border border-label-primary";
    }
  }, s = () => {
    switch (t) {
      case "neutral":
        return n ? "secondary" : "primary";
      case "warning":
        return n ? "secondary" : "quaternary";
      case "aggregated":
        return "primary";
    }
  }, u = i === void 0 ? "" : `(${i})`;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ue(
        "flex justify-center items-center p-2",
        r == "small" ? "py-1 px-2 rounded" : "p-2 rounded-lg",
        o()
      ),
      children: /* @__PURE__ */ l.jsxs(Ve, { variant: r == "small" ? "D1B" : "H3", significance: s(), children: [
        e,
        " ",
        u
      ] })
    }
  );
}, ri = ({ title: e, menuChildren: t, children: r }) => {
  const [n, i] = tr(!1), [o, s] = tr(!1);
  return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-1 pt-3 pb-2 w-[280px] rounded bg-background-primary", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex items-center justify-between p-2 text-label-primary", children: [
      /* @__PURE__ */ l.jsx("a", { href: "/", children: /* @__PURE__ */ l.jsx("button", { children: /* @__PURE__ */ l.jsx(Ua, { width: 47 }) }) }),
      /* @__PURE__ */ l.jsx("button", { onClick: () => s(!o), children: o ? /* @__PURE__ */ l.jsx(qr, { size: 20 }) : /* @__PURE__ */ l.jsx($r, { size: 20 }) })
    ] }),
    !o && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsxs("div", { className: "px-2 py-2 flex items-center justify-between", children: [
        /* @__PURE__ */ l.jsx(Ve, { variant: "H2", children: e }),
        t && /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col z-10", children: [
          /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: () => i(!n),
              className: "flex gap-1 p-2 items-center",
              children: /* @__PURE__ */ l.jsx(Vr, { size: 16, color: "white" })
            }
          ),
          n && /* @__PURE__ */ l.jsx($a, { children: t })
        ] })
      ] }),
      r
    ] })
  ] });
}, ni = ({ filter: e, setFilter: t, onClose: r, onApply: n }) => {
  const i = (o) => {
    const s = [...e];
    s[o].subtle = !s[o].subtle, t(s);
  };
  return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col w-[276px] py-2 rounded bg-background-secondary shadow", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-2 py-2 px-3", children: [
      /* @__PURE__ */ l.jsx(Ve, { className: "grow", variant: "D1B", children: "Filter selection" }),
      /* @__PURE__ */ l.jsx("button", { onClick: r, className: "shrink-0", children: /* @__PURE__ */ l.jsx(Sr, { size: 16, weight: "bold", className: "text-label-primary" }) })
    ] }),
    /* @__PURE__ */ l.jsx(Ar, {}),
    /* @__PURE__ */ l.jsx("div", { className: "flex items-center px-3 pt-3 pb-1", children: /* @__PURE__ */ l.jsx(Ve, { className: "", variant: "D1B", children: "Tags" }) }),
    /* @__PURE__ */ l.jsx("div", { className: "flex flex-wrap px-3 py-2 gap-2 mb-2", children: e.map((o, s) => /* @__PURE__ */ l.jsx(
      "button",
      {
        onClick: () => {
          i(s);
        },
        children: /* @__PURE__ */ l.jsx(qa, { ...o })
      },
      s
    )) }),
    /* @__PURE__ */ l.jsx("div", { className: "flex flex-col px-4 py-1", children: /* @__PURE__ */ l.jsx(zr, { text: "Apply", variant: "neutral", onClick: n }) })
  ] });
}, ai = ({
  isOn: e,
  onChange: t,
  size: r = "medium",
  onBackgroundColor: n,
  offIcon: i,
  onIcon: o
}) => {
  const s = n ? `bg-${n}` : "bg-background-tertiary", u = {
    small: {
      wrapper: "h-[24px] w-[39px] p-[1.5px] rounded-[6px]",
      icon: 12,
      button: "h-[21px] w-[21px] rounded-[4.5px]",
      translateX: "translate-x-[15px]"
    },
    medium: {
      wrapper: "h-[32px] w-[52px] p-[2px] rounded-[8px]",
      icon: 16,
      button: "h-[28px] w-[28px] rounded-[6px]",
      translateX: "translate-x-[20px]"
    },
    large: {
      wrapper: "h-[40px] w-[65px] p-[2.5px] rounded-[10px]",
      icon: 20,
      button: "h-[35px] w-[35px] rounded-[7.5px]",
      translateX: "translate-x-[25px]"
    }
  };
  return /* @__PURE__ */ l.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ue(
        "transition-colors duration-300 ease-in-out flex items-center",
        u[r].wrapper,
        {
          "bg-background-secondary": !e,
          [s]: e
        }
      ),
      children: /* @__PURE__ */ l.jsx(
        "button",
        {
          onClick: () => {
            t(!e);
          },
          className: ue(
            "flex transition-transform duration-300 ease-in-out items-center justify-center text-label-quaternary",
            u[r].button,
            {
              [`${u[r].translateX} bg-label-primary`]: e,
              "bg-label-secondary": !e
            }
          ),
          children: /* @__PURE__ */ l.jsxs(Nt.Provider, { value: { size: u[r].icon }, children: [
            o && e && o,
            i && !e && i
          ] })
        }
      )
    }
  ) });
}, ue = qe, ii = ({ color: e = "#FFF", size: t = 20 }) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    fill: e,
    width: t,
    height: t,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        d: "M3.125 10H16.875",
        stroke: e,
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), oi = ({ color: e = "#FFF", size: t = 20 }) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    fill: e,
    width: t,
    height: t,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        d: "M3.125 10H16.875",
        stroke: e,
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeDasharray: "1 4"
      }
    )
  }
);
export {
  zr as Button,
  Ja as DateSlider,
  ei as Loader,
  Ua as Logo,
  $a as MenuModal,
  za as Pager,
  ti as Popup,
  Ya as SegmentedControl,
  Za as Select,
  Ar as Separator,
  Ka as SignalButton,
  ri as StaticMenuLayout,
  qa as Tag,
  ni as TagFilter,
  ai as Toggle,
  ii as TrackComplete,
  oi as TrackGap,
  Ve as VText,
  m as colors,
  ue as cx,
  Qa as includeGlobalStyles,
  Vt as semanticColors
};
//# sourceMappingURL=index.es.js.map
